import { render, staticRenderFns } from "./APIList.vue?vue&type=template&id=a27a6388&scoped=true&"
import script from "./APIList.vue?vue&type=script&lang=js&"
export * from "./APIList.vue?vue&type=script&lang=js&"
import style0 from "./APIList.vue?vue&type=style&index=0&id=a27a6388&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27a6388",
  null
  
)

export default component.exports